export enum UnicodeChars {
  horizontalEllipsis = '\u2026',
  enDash = '\u2013',
}
